import { Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RealtimeConnection, RealtimeEnvelope } from '@zayan-erp/realtime';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { NotificationEvents, NotificationReceivedPayload } from '../models/notification-events';

@Injectable({ providedIn: 'root' })
export class NotificationsRealtimeService {
  #realtime = inject(RealtimeConnection);
  #toaster = inject(ToastrService);
  #received = new Subject<NotificationReceivedPayload>();

  readonly received$: Observable<NotificationReceivedPayload> = this.#received.asObservable();

  constructor() {
    this.#realtime.envelopes$.pipe(takeUntilDestroyed()).subscribe(envelope => this.#onEnvelope(envelope));
  }

  #onEnvelope(envelope: RealtimeEnvelope): void {
    if (envelope.type !== NotificationEvents.received) {
      return;
    }

    const payload = envelope.payload as NotificationReceivedPayload | undefined;
    if (!payload) {
      return;
    }

    this.#received.next(payload);

    if (payload.showToast) {
      this.#toaster.info(payload.body, payload.header);
    }
  }
}
